import { z } from 'zod';

import { PartnerVehicle } from '../repo/types/PartnerVehicle';

interface VehicleTypesApiResponse {
  vehicle: Record<string, number>;
}

const vehicleTypesSchema: z.ZodType<VehicleTypesApiResponse> = z.object({
  vehicle: z.record(z.string(), z.number()),
});

export function parseVehicleTypes(
  response: unknown,
): PartnerVehicle[] {
  const parsed = vehicleTypesSchema.parse(response);
  return Object.entries(parsed.vehicle).map(([name, id]) => ({ id, name }));
}
